module.exports = __webpack_public_path__ + "img/xiexiecanyu.25117e8b.png";